module.exports = __webpack_public_path__ + "img/visual_no_image_hospitals.f8218fea.png";